const formatTimeUnitUtil = (num) => {
  if (num === null || num === undefined || num === '') return '00'
  return String(num).padStart(2, '0')
}

export default formatTimeUnitUtil
